var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00317383H513V341.989H0V-0.00317383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 -0.00317383V170.993H256.5L0 -0.00317383H513Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 170.993V341.989H0L256.5 170.993H513Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.224 170.993L134.883 158.133L149.443 131.654L119.753 137.333L115.991 107.341L95.3107 129.399L74.6314 107.341L70.869 137.333L41.1802 131.653L55.7395 158.132L28.3982 170.993L55.7395 183.853L41.1802 210.333L70.871 204.654L74.6314 234.645L95.3107 212.587L115.991 234.645L119.753 204.654L149.442 210.334L134.882 183.855L162.224 170.993ZM21.8314 32.3301L30.9302 45.0509L45.8382 40.3277L36.5521 52.9122L45.6509 65.631L30.8129 60.6894L21.5268 73.2729L21.6441 57.6344L6.80615 52.6908L21.7152 47.9696L21.8314 32.3301ZM21.8314 268.714L30.9302 281.435L45.8382 276.711L36.5521 289.296L45.6509 302.016L30.8129 297.073L21.5268 309.656L21.6441 294.018L6.80615 289.075L21.7152 284.353L21.8314 268.714ZM210.806 150.522L201.707 163.242L186.799 158.52L196.085 171.104L186.986 183.824L201.824 178.882L211.11 191.464L210.993 175.827L225.831 170.883L210.922 166.161L210.806 150.522Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00708008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPh);
export default __webpack_public_path__ + "static/media/PH.d346936f22759a47e303c8acd23bcec3.svg";
export { ForwardRef as ReactComponent };